"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImageSettingsToJSON = exports.ProductImageSettingsFromJSONTyped = exports.ProductImageSettingsFromJSON = exports.ProductImageSettings = void 0;
/**
 *
 * @export
 */
exports.ProductImageSettings = {
    AllImages: 0,
    ProductPictures: 1
};
function ProductImageSettingsFromJSON(json) {
    return ProductImageSettingsFromJSONTyped(json, false);
}
exports.ProductImageSettingsFromJSON = ProductImageSettingsFromJSON;
function ProductImageSettingsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ProductImageSettingsFromJSONTyped = ProductImageSettingsFromJSONTyped;
function ProductImageSettingsToJSON(value) {
    return value;
}
exports.ProductImageSettingsToJSON = ProductImageSettingsToJSON;
